import {
  Backdrop,
  Box,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  Modal,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { BCPXmark } from "../../components/icons/bcp/BCPIcons";

export default function StreamOptionsModal(props) {
  const { anchorEl, setAnchorEl, pairing } = props;

  const [hideRolls, setHideRolls] = useState(false);

  return (
    <Modal
      disableAutoFocus
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", "70vw"],
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setAnchorEl(null);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2" gutterBottom>
              Stream Overlay
            </Typography>
            <Typography variant="caption">
              {`Fill out the values for the scorecard to automatically update the overlays below.`}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              label="Hide Rolls"
              control={
                <Switch
                  checked={hideRolls}
                  onChange={() => {
                    setHideRolls(!hideRolls);
                  }}
                />
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Standard
            </Typography>
            <Link
              target="_blank"
              href={`${window.location.origin}/stream/${
                pairing?.id
              }?type=1&embed=true${hideRolls ? "&hideRolls=true" : ""}`}
            >{`${window.location.origin}/stream/${
              pairing?.id
            }?type=1&embed=true${hideRolls ? "&hideRolls=true" : ""}`}</Link>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Inset (right)
            </Typography>
            <Link
              target="_blank"
              href={`${window.location.origin}/stream/${
                pairing?.id
              }?type=2&embed=true${hideRolls ? "&hideRolls=true" : ""}`}
            >{`${window.location.origin}/stream/${
              pairing?.id
            }?type=2&embed=true${hideRolls ? "&hideRolls=true" : ""}`}</Link>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Inset (left)
            </Typography>
            <Link
              target="_blank"
              href={`${window.location.origin}/stream/${
                pairing?.id
              }?type=3&embed=true${hideRolls ? "&hideRolls=true" : ""}`}
            >{`${window.location.origin}/stream/${
              pairing?.id
            }?type=3&embed=true${hideRolls ? "&hideRolls=true" : ""}`}</Link>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
